export enum PhysicalPlatforms {
  WEB,
  ANDROID,
  IOS,
}
